namespace $ {
	export function $mol_base64_decode(base64: string): Uint8Array< ArrayBuffer > {
		throw new Error('Not implemented')
	}
}
